import React from 'react';
import { translate } from '@utils/i18n';
import { NAMESPACE } from '../constants';
export function InstallationYearCell({ item }) {
    return (React.createElement("span", { className: "sprinkler-projection__cell-nowrap" },
        item.installationDate,
        item.yearsInService && (React.createElement(React.Fragment, null,
            ' ',
            React.createElement("span", { className: "sprinkler-projection__cell-annotation" }, translate('years_in_service', { namespace: NAMESPACE, count: item.yearsInService }))))));
}
